import React, { useState, useEffect } from "react";
import { Row, Col, Button, AutoComplete, Input, Form, Skeleton } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import {
  getSearchSkills,
  getCompanyDetailsSuggestions,
  GetFilters,
  getPersonalDetailsLocation,
  updateJobs,
} from "../../../../redux/actions";
import history from "../../../../routes/history";
import { useLocation } from "react-router-dom";
import editjobicon from "../../../../assets/img/editjob.png";
import deletejobicon from "../../../../assets/img/deletejob.png";
import { createGig, createGigReset, updateJobsReset, } from "../../../../redux/actions";

import ContractGig from "../ContractGig/ContractGig";

// Main Function
export default function PerGig() {
  return <ContractGig />;
}
